var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorageSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C7.58 2 4 3.34 4 5v14c0 1.66 3.58 3 8 3s8-1.34 8-3V5c0-1.66-3.58-3-8-3zm0 2c3.87 0 6 .98 6 1s-2.13 1-6 1-6-.98-6-1 2.13-1 6-1zm0 6c3.87 0 6-.98 6-1v2c0 .02-2.13 1-6 1s-6-.98-6-1V9c0 .02 2.13 1 6 1zm0 6c3.87 0 6-.98 6-1v2c0 .02-2.13 1-6 1s-6-.98-6-1v-2c0 .02 2.13 1 6 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.5l3 3-3 3v-2a4.5 4.5 0 0 0-7.9-2.8l-1.4-1.4A6.5 6.5 0 0 1 15.5 9V7.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.5l-3-3 3-3v2a4.5 4.5 0 0 0 7.9 2.8l1.4 1.4A6.5 6.5 0 0 1 8.5 15v1.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageSync);
export default __webpack_public_path__ + "static/media/storage_sync.b180239f29d058b3b708d57087f4db70.svg";
export { ForwardRef as ReactComponent };